import Axios from 'axios';
import { AlarmsResponse } from 'model/api';

export const getAlarms = async (lang?: string): Promise<AlarmsResponse> => {
  const response = await Axios.get(`/alarms${lang ? `?lang=${lang}` : ''}`);
  return response.data;
}